<template>
  <div class="login-mod">

    <div class="form" v-if="!loginFlg">
      <div class="form-item">
        <label class="form-label">用户名</label>
        <div class="form-block">
          <input type="text" placeholder="用户名"   v-model="form.userName">
        </div>
      </div>

      <div class="form-item">
        <label class="form-label">密码</label>
        <div class="form-block">
          <input   type="password"  placeholder="密码"   v-model="form.userPwd">
        </div>
      </div>

      <div class="form-item"  v-if="authImgFlg">
        <label class="form-label">验证码</label>
        <div class="form-block">
          <input type="text" style="width:50px" maxlength="4" class="am-inline" v-model="form.yfRand">
           <img v-if="authImg" @click="changeImg" :src="authImg" style="vertical-align: middle;" class="am-inline">
        </div>
      </div>
      <div class="form-item am-margin-left-sm">
        <button  class="submit-btn" @click="loginSubmit">
          登录
        </button>
      </div>

    </div>
    <ul class="logined-box" v-else>
      <li>欢迎您，{{user.name}}!</li>
      <li>
        <a target="_blank" href="portal_mng">
          <img src="../../assets/images/icon1.png" style="vertical-align: middle;" width="20" alt="">网站后台</a>
      </li>
      <li>
        <a href="/school/" target="_blank">
          <img src="../../assets/images/icon2.png" style="vertical-align: middle;" width="20" alt="">办公平台</a>
      </li>
      <li @click="outLogin()">
        <img src="../../assets/images/icon3.png" style="vertical-align: middle;" width="20" alt="">安全退出
      </li>
    </ul>
   
  </div>
</template>

<script>

  import cookie from 'js-cookie'
  import {
    outLogin,
    login,
    getUserInfo,
    auth,
    getAuthImg
  } from '@/api/base'
  export default {
    data() {
      return {
        authImgFlg: false,
        authImg: '',
        loginFlg: false,
        user: {},
        form: {
          yfRand: '',
          userName: '',
          userPwd: ''
        }
      }
    },
    methods: {
      changeImg() {
        this.authImg = getAuthImg()
      },
      loginSubmit() {
        login(this.form).then(result => {
            this.loginFlg = true
            this.user = result.user
            this.$message.success('登录成功')
            cookie.set('YFCOOKIE', result.token)
        })
      },
      outLogin() {
        outLogin()
        this.loginFlg = false
      }
    },
    created() {
      getUserInfo().then(result => {
        if (result.code == 1) {
          this.loginFlg = true;
          this.user = result.user
        }
      })
      auth().then(result => {
        if (result.code == 1) {
          this.authImgFlg = true
        }
        this.authImg = result.img
      })
    }
  }
</script>

<style lang="scss">
  .login-mod {

    .form {
      .form-item {
        display: inline-block;
         height: 38px;
        line-height: 38px;
        .form-label {
          float: left;
          width: 60px;
          box-sizing: border-box;
          text-align: right;
          padding-right: 12px;
          font-size: 14px;
          color: $primary;
        }

        .form-block {
          margin-left: 60px;
           height: 38px;
        line-height: 38px;
          input{
            &::placeholder{
              color: #bbe3ff;
            }
            display:block ;
            width: 120px;
            color: $primary;
            height: 38px;
            border: 1px solid #91d1ff;
            box-sizing: border-box;
            padding-left: 10px;
            outline: none;
          }
        }
      }
    }

    .title-mod {}

    .logined-box {
      padding-left: 40px;
      li {
        height: 38px;
        line-height: 38px;
        vertical-align: middle;
        padding: 0 12px;
        display: inline-block;
        cursor: pointer;
        font-size: 14px;
        color: $primary;
        img{
          margin-right: 4px;
        }

        &:hover {
          background-color: $primary;

          color: white;
        }

      }
    }

    .submit-btn {
      &:hover {}
  border: none;
  background-color: $primary;
  height: 38px;
  padding: 0 12px;
      cursor: pointer;

color: white;
    }
  }
</style>